import { Button, Grid, Popover } from '@mui/material';
import DateField from 'common/forms/DateField';
import TextField from 'common/forms/TextField';
import { validateMinLength } from 'common/forms/formValidations';
import { useState } from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { filterTransactions } from 'store/thunks/transactionsThunk';

const dateToUTCString = (date) => {
  if (!date) return null;
  return date.toISOString();
};

const utcStringToLocalDate = (isoString) => {
  if (!isoString) return null;
  return new Date(isoString);
};

const TransactionsFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const loading = useSelector(({ transactions }) => transactions.loading);

  const filter = useSelector(({ transactions }) => ({
    ...transactions.filter,
    transactionDate:
      transactions.filter?.transactionDate &&
      utcStringToLocalDate(transactions.filter.transactionDate),
  }));

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const popoverId = anchorEl ? 'Transactions-filterButton-Popover' : undefined;

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);

    dispatch(
      filterTransactions({
        filter: {
          ...formData,
          transactionDate: formData.transactionDate && dateToUTCString(formData.transactionDate),
        },
      })
    );
  };

  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Patient Name'
                      name='patientName'
                      id='transactions-filterButton-patientName-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Transaction Id'
                      name='externalTransactionId'
                      id='transactions-filterButton-transactionId-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <DateField
                      label='Transaction Created At'
                      name='transactionDate'
                      id='transactions-filterButton-transactionDate-dateField'
                      maxDate={new Date()}
                    />
                  </Grid>
                  <Grid container justifyContent='flex-end'>
                    <LoadingButton
                      loading={loading}
                      type='submit'
                      variant='contained'
                      disabled={invalid}
                    >
                      Apply
                    </LoadingButton>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default TransactionsFilterButton;
